// Textos do cardápio em inglês. Mesmas chaves de pt-BR.js; o que faltar aqui aparece em português.

export default {
    geral: {
        continuar: 'Continue',
        concluir: 'Done',
        cancelar: 'Cancel',
        ok: 'Ok',
        todas: 'All',
        pesquisar: 'Type to search...',
        quantidade: 'Quantity',
        idioma: 'Language',
        observacao: 'Note',
    },

    sistema: {
        formaEntrega: {
            1: 'Pickup',
            2: 'Delivery',
            3: 'Dine-in',
        },
        formaPagamento: {
            1: 'Cash',
            2: 'Credit card',
            3: 'Pix',
            4: 'Debit card',
        },
    },

    horario: {
        fechado: 'CLOSED',
        fechadoHoje: 'CLOSED TODAY',
        abertoAte: 'OPEN UNTIL {hora}',
        fechadoAbre: 'CLOSED, OPENS AT {hora}',
        titulo: 'Opening hours',
        dias: {
            1: 'Monday',
            2: 'Tuesday',
            3: 'Wednesday',
            4: 'Thursday',
            5: 'Friday',
            6: 'Saturday',
            7: 'Sunday',
        },
    },

    produto: {
        aPartirDe: 'From {valor}',
        esgotadoCaixaAlta: 'SOLD OUT',
        esgotado: 'Sold out',
        avisoEsgotado: 'Sold out',
        indisponivel: 'Unavailable',
        restamUnidades: '{n} left',
        restaUma: 'Only 1 left',
        restamEmEstoque: 'Only {n} left in stock',
        resgatePor: 'Redeem for {n} points',
    },

    cardapio: {
        agendeSeuPedido: 'Schedule your order!',
        entrega: 'Delivery',
        retirada: 'Pickup',
        horarios: 'Hours',
        localizacao: 'Location',
        fidelidadeTitulo: 'Loyalty program',
        fidelidadeTexto: 'For every {valor} you spend you earn {ponto} that can be redeemed for rewards.',
        umPonto: '1 point',
        semProdutos: 'Oops! Our menu is still being set up. Come back later to check it out!',
        estamosFechados: 'We are closed right now, please check our opening hours',
        prazo: '{inicio} to {fim}',
        inicio: 'Home',
        pesquisarProduto: 'Search for a product',
    },

    etapa: {
        valorAdicional: 'Extra: {valor}',
        nenhumaOpcao: 'No options found.',
        irPara: 'Go to {produto}',
        estoqueDisponivel: 'Available in stock: {n}',
        quantidadeMaxima: 'Maximum quantity allowed: {n}',
        escolhaUma: 'Choose one option',
        escolhaAoMenos: 'Choose at least {n}',
        minimoDe: 'Minimum {n} of {item}',
        escolhidoUm: ' · {n} selected',
        escolhidos: ' · {n} selected',
        escolha1Opcao: 'Choose 1 option',
        escolha1SeQuiser: 'Choose 1, optional',
        escolhaN: 'Choose {n}{escolhidos}',
        escolhaDeAte: 'Choose {min} to {max}{escolhidos}',
        ateOpcoes: 'Up to {max} options{escolhidos}',
        opcional: 'Optional',
        obrigatorio: 'Required',
        pronto: 'Done',
        progresso: 'Step {atual} of {total}',
        digitarQuantidadeDe: 'Tap to type the quantity of {item}',
        quantidadeDe: 'Quantity of {item}',
        digitarQuantidade: 'Tap to type the quantity',
    },

    resumo: {
        titulo: 'Review your order!',
        entregaGratisAPartir: 'Free delivery on orders over {valor}',
        entregaGratis: 'Free delivery',
        premios: '{n} {produtos} in your cart can be redeemed with points',
        produto: 'item',
        produtos: 'items',
        pontosDisponiveis: '{n} points available',
        entreParaAcumular: 'Sign in or sign up to earn points!',
        subtotal: 'Subtotal: {valor}',
        semPontos: 'Not enough points',
        resgatar: 'Redeem',
        resgatou: 'Redeemed for {n} points',
        desfazer: 'Undo',
        total: 'TOTAL {valor}',
        continuarComprando1: 'Keep',
        continuarComprando2: 'Shopping',
        finalizarPedido1: 'Place',
        finalizarPedido2: 'Order',
        digiteObservacao: 'Type your note...',
        adicional: '(Extra {valor})',
    },

    orderBump: {
        minimo: 'Minimum: {n}',
        maximo: 'Maximum: {n}',
        valorAdicional: 'Extra: {valor}',
        escolhaNoMinimo: 'Choose at least {n}',
    },

    endereco: {
        codigoPostal: { BR: 'CEP (postal code)', US: 'ZIP code' },
        estado: { BR: 'State', US: 'State' },
        bairro: 'Neighborhood',
        bairroOpcional: 'Neighborhood (optional)',
        rua: 'Street',
        numero: 'Number',
        pontoReferencia: 'Landmark / directions',
        nomePredio: 'Building name',
        numeroApartamento: 'Apt / Unit',
        selecioneMunicipio: 'Select your city',
        selecioneBairro: 'Select your neighborhood',
        padrao: 'default',
        tipo: {
            casa: 'House',
            apartamento: 'Apartment',
            trabalho: 'Work',
            condominio: 'Condo',
            endereco: 'Address',
        },
    },

    envio: {
        titulo: 'Fill in your details',
        nomeCompleto: 'Full name',
        whatsapp: 'WhatsApp',
        emailOpcional: 'Email (optional)',
        emailDica: 'We will email you when your order is ready.',
        aniversario: 'Birthday',
        formatoAniversario: 'MM/DD',
        entregar: 'Delivery',
        vouRetirar: 'Pickup',
        consumirNoLocal1: 'Dine',
        consumirNoLocal2: 'in',
        quandoSera: 'When should we deliver / have it ready?',
        hoje: 'Today',
        agendar: 'Schedule',
        dataAgendamento: 'Scheduled date',
        horario: 'Time',
        formatoData: 'MM/DD/YYYY',
        enderecoEntrega: 'Delivery address',
        informeEnderecoEntrega: 'Add your delivery address',
        alterar: 'Change',
        informar: 'Add',
        seusEnderecos: 'Your addresses',
        definirPadrao: 'Set as default',
        excluir: 'Delete',
        cadastrarOutro: 'Add another address',
        gerenciarEnderecos: 'Manage addresses',
        editarEndereco: 'Edit address',
        confirmar: 'Confirm',
        temCupom: 'Have a coupon?',
        informeCupom: 'Enter your coupon',
        aplicar: 'Apply',
        cupomPrimeiroPedido: 'This coupon is valid for your first order.',
        cupomExclusivo: 'This coupon is only for registered customers.',
        entrarOuCriarConta: 'Sign in or create an account',
        entrar: 'Sign in',
        restaUmUso: '1 use left',
        restamUsos: '{n} uses left',
        regras: 'Rules:',
        regraPrimeiroPedido: 'Valid only for your {destaque}',
        primeiroPedido: 'first order',
        regraGrupos: 'Valid only for these product groups: {lista}',
        regraEntrega: 'Valid only for: {lista}',
        regraPagamento: 'Valid only when paying with: {lista}',
        regraValorMinimo: 'Valid for orders over {valor}',
        faltam: '({valor} to go)',
        separadorOu: ' or ',
        trocoParaQuanto: 'Change for how much?',
        naoPrecisoTroco: 'I don\'t need change',
        copiarPix: 'Copy Pix key',
        subtotal: 'Subtotal',
        acrescimo: 'Surcharge',
        desconto: 'Discount',
        premio: 'Reward',
        taxaEntrega: 'Delivery fee',
        total: 'Total',
        pagar: 'Pay',
        enviar: 'Send',
        pedidoConfirmado: 'Order confirmed!',
        filaPreparo1: 'Your order is now',
        filaPreparo2: 'being prepared.',
        envieNoWhatsapp: 'Send the order on WhatsApp to follow its progress!',
        enviarNoWhatsapp: 'Send on WhatsApp',
        acompanharPedido: 'Track order',
        confirmacao: 'Confirmation',
        confirmaEndereco: 'Please confirm your address:',
        excluirEnderecoTitulo: 'Delete address',
        excluirEnderecoTexto: 'Do you want to delete this address from your account?',
        enderecoAlteradoTitulo: 'Address changed',
        enderecoAlteradoTexto: 'You changed the selected address.<br><br>Tap <b>Confirm</b> to <b>update it</b>, or <b>Save as new</b> to keep the previous one and create a new address.',
        salvarComoNovo: 'Save as new',
        avisos: {
            cupomExclusivoRemovido: 'The exclusive coupon was removed because you signed out',
            informeRuaNumero: 'Enter at least the street and number',
            selecioneTipoEndereco: 'Select the address type (house, apartment or work)',
            codigoPostalValido: 'Enter a valid {rotulo}',
            naoSalvouEndereco: 'Could not save the address',
            naoDefiniuPadrao: 'Could not set the default address',
            naoExcluiuEndereco: 'Could not delete the address',
            encerramosAgende: 'Sorry! We are closed now, but you can schedule your order',
            encerramos: 'Sorry! We are closed now',
            foraDoRaio: 'Sorry! Outside our delivery area',
            valorMinimo: 'The minimum order is {valor}',
            aniversarioInvalido: 'Enter a valid month and day for your birthday',
            nomeSobrenome: 'Enter your first and last name',
            informeNome: 'Enter your name',
            informeWhatsapp: 'Enter your WhatsApp number',
            selecioneFormaEntrega: 'Choose delivery or pickup',
            informeDataAgendamento: 'Choose the scheduled date',
            informeHoraAgendamento: 'Choose the scheduled time',
            informeFormaPagamento: 'Choose a payment method',
            informeTroco: 'Enter the amount you will pay with',
            trocoMaiorQueTotal: 'The amount must be higher than the order total',
            selecioneNoMapa: 'Select the address on the map',
            informeMunicipio: 'Enter the city',
            informeBairro: 'Enter the neighborhood',
            selecioneMunicipioLista: 'Select the city from the list to calculate delivery',
            selecioneBairroLista: 'Select the neighborhood from the list to calculate delivery',
            informeRua: 'Enter the street',
            informeNumero: 'Enter the street number',
            informeTipoLocal: 'Choose the address type',
            informeEdificio: 'Enter the building name',
            informeApartamento: 'Enter the apartment number',
            informeCodigoPostalEntrega: 'Enter the {rotulo} for delivery',
            muitasTentativasCupom: 'Too many coupon attempts. Wait 1 minute and try again.',
            verifiqueConexao: 'Check your internet connection',
            cupomInvalido: 'Invalid or expired coupon',
            cupomParabens: 'Congrats, coupon applied',
            loginSucesso: 'Signed in successfully',
            cupomAplicado: 'Coupon applied',
            faltamParaCupom: '{valor} more for this coupon to apply',
            taxaEntrega: 'Delivery fee {valor}',
            pixCopiada: 'Pix key copied!',
            naoCopiou: 'Could not copy!',
            envieAntesDeSair: 'Attention: send your order before leaving this page. Tap the green "Send" button',
            localizacaoConfirmada: 'Location confirmed!',
            enderecoNaoEncontrado: 'Address not found',
            semRotas: 'There are no routes to this address',
            falhaDistancia: 'Could not calculate the distance',
            falhaGeocodificacao: 'Could not find the address on the map',
            cupomRemovido: 'Coupon removed',
        },
        mensagem: {
            pedido: '*ORDER #{id}*',
            agendadoPara: '*SCHEDULED FOR*: {data} {hora}',
            nome: '*Name*: {valor}',
            whatsapp: '*WhatsApp*: {valor}',
            formaEntrega: '*Order type*: {valor}',
            prazo: '*Estimated time*: {valor}',
            pagamento: '*Payment*: {valor}',
            endereco: '*Address*: {valor}',
            obs: '*Note*: {valor}',
            cupom: '*Coupon*: {valor}',
            premioItem: '(REWARD)',
            obsItem: '_Note: ({valor})_',
            adicional: '(Extra {valor})',
            totalProdutos: '*ITEMS TOTAL*: {valor}',
            premio: '*REWARD*: - {valor}',
            taxaEntrega: '*DELIVERY FEE*: {valor}',
            aCombinar: 'To be arranged',
            totalFinal: '*GRAND TOTAL*: {valor}',
            trocoPara: '*Change for*: {valor}',
            total: '*TOTAL*: {valor}',
            obrigado: 'Thank you for your order!',
            envieLocalizacao: '_To make delivery easier, send us your WhatsApp location_',
            acompanhe: '*👉Track your order:* {link}',
            formatoDataHora: 'MM/DD/YYYY h:mm A',
        },
    },

    pagamentoForma: {
        rotulo: 'Payment method',
    },

    status: {
        carregando: 'Updating your order information...',
        verifiqueLink: 'Check that the link is correct or contact the restaurant.',
        voltarInicio: 'Back to home',
        pedido: 'Order',
        realizadoEm: 'Placed on {data}',
        cancelado: 'This order was canceled',
        finalizado: 'Order completed',
        previsao: 'Estimated ready time',
        pronto: 'Ready',
        aguardandoTempo: 'Waiting for the preparation time.',
        acompanheAbaixo: 'Follow your order progress below.',
        toqueAtualizar: 'Tap {botao} to see the latest information.',
        atualizarStatus: 'Refresh status',
        passoRealizado: 'Order placed',
        passoPreparacao: 'Being prepared',
        entrouNaFila: 'Started at {hora}',
        passoSaiu: 'Out for delivery',
        aCaminho: 'Your order is on its way',
        passoAguardandoRetirada: 'Ready for pickup',
        retirarNoBalcao: 'As soon as it is ready you can pick it up at the counter',
        passoConcluido: 'Completed',
        foiConcluido: 'Your order is complete',
        ultimaAtualizacao: 'Last updated: {hora}',
        cliente: 'Customer',
        formaEntrega: 'Order type',
        formaPagamento: 'Payment method',
        total: 'Total',
        entrega: {
            1: 'Pickup at the counter',
            2: 'Delivery',
            3: 'Dine-in',
        },
        rotulos: {
            cancelado: 'Canceled',
            confirmado: 'Confirmed',
            em_preparacao: 'Being prepared',
            aguardando_retirada: 'Ready for pickup',
            saiu_para_entrega: 'Out for delivery',
            concluido: 'Completed',
        },
        naoEncontrado: 'Order not found 😕',
        naoConcluiu: 'Something went wrong 😕',
        naoConcluiuAviso: 'Something went wrong',
        formatoCriadoEm: 'MMMM D, h:mm A',
        formatoHora: 'h:mm A',
        formatoHoraSegundos: 'h:mm:ss A',
    },

    conta: {
        senhaRegra: 'Your password must have at least 8 characters, with at least 1 letter and 1 number',
        obrigatorio: 'Required',
        digiteCodigoWhatsapp: 'Enter the code you received on WhatsApp',
        reenviarCodigo: 'Resend code',
        crieSenha: 'Create your password',
        confirmeSenha: 'Confirm your password',
        digiteCodigo: 'Enter the code',
        whatsappInvalido: 'Invalid WhatsApp number',
        naoEnviouCodigo: 'Could not send the code. Please try again in a moment.',
        senhaNaoConfere: 'Passwords do not match',
        preenchaTodos: 'Fill in all the fields',
        novaSenha: 'New password',
        redefinir: 'Reset',
        digiteNovaSenha: 'Enter your new password',
        digiteSenha: 'Enter your password',
        digiteWhatsapp: 'Enter your WhatsApp number',
        whatsapp: 'WhatsApp',
        senha: 'Password',
        esqueciSenha: 'Forgot my password',
        digiteASenha: 'Enter your password',
        oi: 'Hi, {nome}',
        minhaConta: 'My account',
        sair: 'Sign out',
        desejaSair: 'Do you really want to sign out?',
        usuario: 'User',
        pontosFidelidadeN: '{n} loyalty points',
        meusDados: 'My details',
        enderecos: 'Addresses',
        pedidos: 'Orders',
        nome: 'Name',
        whatsappRotulo: 'WhatsApp',
        pontosFidelidade: 'Loyalty points',
        nPontos: '{n} points',
        carregandoPedidos: 'Loading your orders...',
        nenhumPedido: 'No orders yet',
        pedidosUltimos6Meses: 'Your orders from the last 6 months show up here.',
        contagemPedido: '{n} order · last 6 months',
        contagemPedidos: '{n} orders · last 6 months',
        pedidoN: 'Order #{id}',
        formatoDataHora: 'MM/DD/YYYY h:mm A',
        statusPedido: {
            aguardando_pagamento: 'Awaiting payment',
            pago: 'Paid',
            recebido: 'Received',
            cancelado: 'Canceled',
            confirmado: 'Confirmed',
            em_preparacao: 'Being prepared',
            saiu_para_entrega: 'Out for delivery',
            aguardando_retirada: 'Ready for pickup',
            concluido: 'Completed',
        },
    },

    meusEnderecos: {
        nenhum: 'No saved addresses',
        padrao: 'Default',
        editar: 'Edit',
        remover: 'Remove',
        adicionar: 'Add address',
        maximo: '(max. {n})',
        novo: 'New address',
        apelido: 'Nickname (optional)',
        apelidoExemplo: 'E.g.: Home, Work, Mom\'s place',
        municipio: 'City',
        rua: 'Street',
        referencia: 'Landmark / details',
        numeroApto: 'Apt / Unit',
        usarComoPadrao: 'Use as default address',
        salvar: 'Save address',
        erroCarregar: 'Could not load your addresses',
        informeRuaNumero: 'Enter at least the street and number',
        selecioneTipo: 'Choose the type (House, Apartment or Work)',
        salvo: 'Address saved',
        erroSalvar: 'Could not save the address',
        erroPadrao: 'Could not set the default address',
        removerTitulo: 'Remove address',
        removerTexto: 'Do you want to remove this address?',
        removido: 'Address removed',
        erroRemover: 'Could not remove the address',
    },

    tablet: {
        semConexao: 'No connection to the server',
        mesaSemCardapio: 'The table is set up, but the menu could not be loaded. Check the restaurant network.',
        tentarDeNovo: 'Try again',
        mesaNaoConfigurada: 'Table not set up',
        naoAssociado: 'This tablet is not linked to a table yet.',
        configurePainel: 'Set it up in the tablet panel: tap the top left corner of the screen 5 times and enter the PIN.',
        nenhumProduto: 'No products found for “{busca}”.',
        tenteOutra: 'Try another word or pick a category from the menu on the side.',
        limparBusca: 'Clear search',
        colunas: {
            hora: 'Time',
            qtd: 'Qty',
            item: 'Item',
            unitario: 'Unit price',
            valor: 'Amount',
        },
        filaPreparo: 'Your order is now being prepared.',
        okObrigado: 'Ok, thanks',
        carrinhoCompras: 'Shopping cart',
        carrinhoVazio: 'Your cart is empty',
        carrinhoVazioTexto: 'Choose a product from the menu and it will show up here for you to review before sending it to the kitchen.',
        verCardapio: 'See menu',
        itensEnviados: 'You already have items sent from this table — see {conta}.',
        adicionarAoPedido: 'Add to order',
        reservado: 'RESERVED',
        reservadoPara: 'for {nome}',
        toqueParaFechar: 'Tap to close',
        mesa: 'TABLE {n}',
        mesaN: 'Table {n}',
        minhaConta1: 'My',
        minhaConta2: 'Tab',
        carrinho: 'Cart',
        observacoes: 'Notes',
        observacoesExemplo: 'E.g.: no onions, medium rare...',
        confiraPedido: 'Review your order',
        semPersonalizacao: 'You did not add any customization.',
        voltar: 'Back',
        confiraProduto: 'Check the product',
        adicioneAoCarrinho: 'Add to cart',
        revisaoPedido: 'Order review',
        adicionar: 'Add',
        personalizar: 'Customize',
        falta: 'Missing: {etapa}',
        horariosFuncionamento: 'Opening hours',
        fechado: 'Closed',
        anuncioZaper: 'Smart digital menu for your restaurant',
        configuracaoMesa: 'Table setup',
        trocarMesa: 'To change the table, use the tablet panel: tap the top left corner of the screen 5 times and enter the PIN.',
        reservarMesa: 'Reserve table',
        fechar: 'Close',
        nomeClienteOpcional: 'Customer name (optional)',
    },

    mapa: {
        trocarEndereco: 'Change address',
        selecionarNoMapa: 'Select address on the map',
        selecioneLocalizacao: 'Select your location',
        instrucao: 'Pick your location on the map or use the "My location" button.',
        meuLocal: 'My location',
        salvar: 'Save',
    },

    rodape: {
        sigaRedes: 'Follow us on social media!',
        desenvolvidoPor: 'Developed by {empresa} with ☕ & ❤️',
        queroCriar: 'I want my own Digital Menu',
        aguardeCarregando: 'Please wait, loading...',
        imprimir: 'Print',
    },

    estoque: {
        semEstoqueTitulo: 'Out of stock!',
        semEstoqueVazio: 'Sorry, this product is out of stock. Go back to the menu to continue your order.',
        disponivel: ' | Available: {n}',
        semEstoqueTexto: 'Sorry, the products above are no longer in stock.',
        semEstoqueVoltar: 'You can {destaque} and add other products to your order before placing it.',
        voltarAoCardapioMinusculo: 'go back to the menu',
        voltarAoCardapio: 'Back to menu',
        indisponivelTitulo: 'Item unavailable!',
        indisponivelTexto: 'Sorry, the items above are no longer available.',
        indisponivelRemovidos: 'They will be removed from your cart so you can continue.',
    },
};
